import React, { Component } from "react";
import { connect } from "react-redux";
import { MatspecComponent } from "./MatspecComponent";
import { StatusBadgeComponent } from "../StatusBadge/StatusBadgeComponent";
import {
  setCurrentMatspec,
  setCurrentTab
} from "./../../../redux/actions/index";
import { setTableFieldPairs } from "../../../components/Helpers";
import { Row, Col } from "antd";

const mapDispatchToProps = dispatch => {
  return {
    setCurrentMatspec: matspec => dispatch(setCurrentMatspec(matspec)),
    setCurrentTab: key => dispatch(setCurrentTab(key))
  };
};

const mapStateToProps = state => {
  return {
    booking: state.booking,
    language: state.language,
    bookingType: state.bookingType,
    configuration: state.configuration,
    fieldTranslations: state.fieldTranslations,
    currentMatspec: state.currentMatspec
  };
};

class Matspec extends Component {
  setCurrentMatspec = matspecObj => {
    const { matspec, setCurrentTab, booking } = this.props;
    console.log("matspec", matspec);
    console.log("matspecObj", matspecObj);
    setCurrentTab("3");
    this.props.setCurrentMatspec(
      matspecObj && matspecObj.admaterial ? matspecObj : matspec
    );
  };
  scrollIntoView = id => {
    const elem = document.getElementById(id);
    if (elem) elem.scrollIntoView();
  };
  componentDidMount() {
    const { bookingType, booking, currentMatspec, setCurrentTab } = this.props;
    if (bookingType !== "DIGITAL_PRINTED" && booking.matspecs.length === 1) {
      this.setCurrentMatspec();
    } else {
      if (!currentMatspec && booking) {
        const initialMatspec = booking.matspecs.filter(
          matspec => matspec.id === booking.currentMaterialSpecification
        );
        if (
          initialMatspec[0].printed &&
          (bookingType === "DIGITAL_PRINTED" || bookingType === "PRINTED")
        ) {
          //setCurrentTab("2");
          this.setCurrentMatspec(initialMatspec[0]);
          return
        }
      }
    }
    this.scrollIntoView(
      currentMatspec ? currentMatspec.id : booking.currentMaterialSpecification
    );
    console.log("booking current ad material");
    if (booking.currentAdMaterial) this.setCurrentMatspec();
  }
  render() {
    const {
      matspec,
      onClick,
      setCurrentMatspec,
      language,
      configuration,
      fieldTranslations,
      booking,
      currentMatspec
    } = this.props;
    const tableData = setTableFieldPairs(
      configuration.tableFieldsMatspecMobile,
      fieldTranslations,
      matspec
    );
    let creativesToReview = matspec.admaterial.filter(
      admaterial =>
        admaterial.status.code !== 510 &&
        admaterial.status.code !== 100005 &&
        admaterial.status.code !== 519
    );
    creativesToReview = creativesToReview.length;
    return (
      <MatspecComponent
        id={matspec.id}
        name={matspec.name}
        onClick={this.setCurrentMatspec}
        highlighted={
          currentMatspec
            ? currentMatspec.id === matspec.id
            : booking && booking.currentMaterialSpecification === matspec.id
        }
      >
        <Row>
          <Col span={24}>
            <div className="custom--hr" />
          </Col>
          <Col span={12}>
            {!matspec.printed && (
              <ul className="mobile--list">
                <li style={{ color: "#f39c12" }}>
                  {creativesToReview} of {matspec.admaterial.length}{" "}
                  {language.data.creativeNeedReview}
                </li>
              </ul>
            )}
            {matspec.printed && (
              <ul className="mobile--list">
                <li>1 Creative</li>
              </ul>
            )}
          </Col>
          <Col span={12}>
            <StatusBadgeComponent status={matspec.status} />
          </Col>
          <Col span={24}>
            <ul className="mobile--list">
              {tableData &&
                tableData.map((field, index) => (
                  <li key={index}>
                    <span className="mobile--list--property">
                      {field.prop}
                      {": "}
                    </span>
                    {field.val}
                  </li>
                ))}
            </ul>
          </Col>
        </Row>
      </MatspecComponent>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Matspec);

//THIS SHOULD BE MIGRATED TO MATSPECCOPONENT???



// WEBPACK FOOTER //
// ./src/components/Mobile/Matspec/MatspecContainer.js